'use strict';

import messageBarTemplate from './messageBar.directive.html';

export default angular
  .module('maestro.directives.components.message-bar', [])
  .directive('appMessageBar', function() {
    return {
      restrict: 'E',
      template: messageBarTemplate,
      transclude: true,
      replace: true,
      scope: {
        onClose: '&',
        header: '@',
        text: '@',
        icon: '@',
        dismissible: '<',
        type: '@',
        class: '@',
        newUserLink: '@',
        newUserLinkParams: '@',
      },
      controller: ($scope, $rootScope, $attrs, $state) => {

        // Validate type
        const types = ['info', 'positive', 'success', 'warning', 'negative', 'error'];
        if (types.indexOf($scope.type) === -1) {
          $scope.type = undefined;
        }

        // Validate spacing
        const spacing = ['empty-top', 'tiny-top', 'bit-top', 'half-top', 'full-top', 'double-top'];
        const hasSpacing = $scope.class && spacing.some(s => $scope.class.split(' ').includes(s));

        angular.extend($scope, {
          openNewUser: openNewUser,
          className: [$scope.type, !hasSpacing ? 'double-top' : ''].filter(Boolean).join(' '),
        });

        applyIcon($scope.icon);

        $attrs.$observe('icon', applyIcon);
        $scope.close = function() {
          $scope.onClose();
        };

        function applyIcon(icon) {
          icon = (icon || '').trim() || 'fal fa-graduation-cap';
          if (icon.split(' ').length === 1) {
            icon = 'fal ' + icon;
          }
          $scope.iconInternal = icon;
        }

        function openNewUser() {
          $rootScope.$emit('refreshChooseMenuEvent', 'users');
          $state.go($scope.newUserLink, $scope.newUserLinkParams ? angular.fromJson($scope.newUserLinkParams) : {});
        }
      }
    };
  })

  .name;
